export default {
    methods: {
        formattedSum(sum) {
            let parts = sum.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return parts.join(".");
        },
    }
}